import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';

import InstallPackageModal from '../discover/InstallPackageModal';
import DialogLoadState from '../common/DialogLoadState';
import { Skeleton } from '../loading';
import { getPackage } from '../../services/packages';

/**
 * "Add an add-on" from a bundle's group in the Card Library (KPR-1130): today's
 * install dialog, opened on THIS collection. The dialog wants the package's
 * page (its add-ons, with their words), which the group does not carry, so it
 * is read when the dialog opens: a frame with the skeleton, or the error with
 * Retry, and then the install dialog itself with the collection already chosen.
 * Rendered only while open (the caller mounts it for one bundle at a time).
 */
export default function BundleAddOnDialog({ bundleKey, bundleName, collectionId, onClose }) {
	const [state, setState] = useState({ pkg: null, error: false });
	const [again, setAgain] = useState(0);

	useEffect(() => {
		let live = true;
		setState({ pkg: null, error: false });
		getPackage(bundleKey)
			.then((pkg) => { if (live) setState({ pkg, error: false }); })
			.catch(() => { if (live) setState({ pkg: null, error: true }); });
		return () => { live = false; };
	}, [bundleKey, again]);

	if (state.pkg) {
		return <InstallPackageModal pkg={state.pkg} open onClose={onClose} initialTargetId={collectionId} />;
	}
	return (
		<Modal open title={bundleName ? `Add an add-on to ${bundleName}` : 'Add an add-on'} onCancel={onClose} footer={null} destroyOnClose>
			<DialogLoadState
				loaded={false}
				loading={!state.error}
				error={state.error}
				label='the add-ons'
				onRetry={() => setAgain(n => n + 1)}
				skeleton={<Skeleton variant='form-field' count={2} />}
				minHeight={96}
			/>
		</Modal>
	);
}
